import { PagePerformedByRequestDTO } from './page-performed-by-request-dto';

export interface FilterDataRequestDTO extends PagePerformedByRequestDTO {
    filterBy?: string;
    filterText?: string;
}
